import { TRESPONSE_HOLIDAY_LIST } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import moment from 'moment';

export const MM_HOLIDAY_LIST_TABLE_MODEL = {
  createModel: (items: TRESPONSE_HOLIDAY_LIST['holidays']) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        select: {
          position: 'START',
          isMulti: true,
          size: 'DEFAULT',
        },
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'table_model.Date',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.Description',
            liftedInput: {
              input: {
                type: 'INPUT',
                subType: 'text',
                setValue: (v) => v.description,
              },
              metadata: {
                keyName: 'description',
                label: 'table_model.Description',
                isRequired: false,
              },
            },
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.AddedBy',
          },
          {
            type: 'TEXT_CELL',
            text: '',
            widthInPx: 32,
          },
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          isSelected: false,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.dateString,
            },
            {
              type: 'TEXT_CELL',
              text: item.description ?? '--',
            },
            {
              type: 'TEXT_CELL',
              text: item.addedBy,
            },
            {
              type: 'ACTION_CELL',
              actionType: 'DELETE',
              asIcon: true,
            },
          ],
        };
      },
    );
  },
};
